import React, { useContext, useMemo, memo } from 'react';
import { AdvancedSearchV2Context } from './AdvancedSearchV2Context';

const InlineLabel = ({ filter, toggle }) => {
  const handleClick = () => {
    toggle(filter.value);
  };

  const isDisabled = useMemo(() => {
    const now = new Date();
    const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12

    // Determine which quarter we're currently in
    let currentQuarter;
    if (currentMonth >= 1 && currentMonth <= 3) {
      currentQuarter = 1; // Q1: Jan-Mar
    } else if (currentMonth >= 4 && currentMonth <= 6) {
      currentQuarter = 2; // Q2: Apr-Jun
    } else if (currentMonth >= 7 && currentMonth <= 9) {
      currentQuarter = 3; // Q3: Jul-Sep
    } else {
      currentQuarter = 4; // Q4: Oct-Dec
    }

    switch (filter.label) {
      case 'Q1':
        return currentQuarter < 1;
      case 'Q2':
        return currentQuarter < 2;
      case 'Q3':
        return currentQuarter < 3;
      case 'Q4':
        return currentQuarter < 4;
      case 'YTD':
      case '90d':
      default:
        return false;
    }
  }, [filter?.label]);

  const labelClasses = useMemo(() => {
    const classes = filter.checked ? 'ft' : 'empty';
    return isDisabled ? `${classes} disabled` : classes;
  }, [filter?.checked, isDisabled]);

  return (
    <span
      className={`vertical-item ${labelClasses}`}
      key={`tier${filter.label}`}
      onClick={!isDisabled ? handleClick : undefined}
    >
      {filter.label}
    </span>
  );
};

const AdvancedSearchTimeframeFilter = ({ filterList, filterLabel }) => {
  const [state, dispatch] = useContext(AdvancedSearchV2Context);
  const toggle = (value) => dispatch({ filterList, value });

  const filters = state.siteFilters[filterList];

  return (
    <div className="company-score vertical-expertise search-filter">
      <div>
        <label>{filterLabel}</label>
        <span className="score">
          {filters.map((filter, index) => (
            <InlineLabel key={index} filter={filter} toggle={toggle} />
          ))}
        </span>
      </div>
    </div>
  );
};

export default memo(AdvancedSearchTimeframeFilter);
